import React, {useState, useCallback} from "react";
import { useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import { Btn, H3 } from "../../../AbstractElements";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Form, CardHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2'
import {Breadcrumbs} from "../../../AbstractElements";
import CloseModal from "../../../Constant/CloseModal";

const Role = () => {

    const [toggleDelet, setToggleDelet] = useState(false);
    const [large, setLarge] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [formdata, setFormdata] = useState({ role: "", description: ""});

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
      } = useForm();

      const LargeModaltoggle = () => {
        setLarge(!large)
      }

    const roleList = [{
        ind: 1,
        role: "Admin",
        description: "Owner",
        action: (
            <span>
              <Btn
                attrBtn={{
                  style: { width: 60, fontSize: 14, padding: 4 },
                  color: 'success',
                  className: 'btn btn-xs',
                  type: 'button',
                //   onClick: () => handleEdit(row),
                }}
              >
                Edit
              </Btn>
            </span>
          ),
    }]
    const tableColumns = [
        {
            name: '#',
            selector: row => row['ind'],
            sortable: true,
            center: false,
        },
        {
            name: 'Role',
            selector: row => row['role'],
            sortable: false,
            center: false,
        },
        {
            name: 'Description',
            selector: row => row['description'],
            sortable: false,
            center: false,
        },
        {
            name: 'Action',
            selector: row => row['action'],
            sortable: false,
            center: true,
        },
    ]

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const onSubmit = async (data) => {
        console.log(data)
        setFormdata((prev) => ({ ...prev, ...data }));
        // setSteps((prev) => prev + 1);
        const formattedData = {
          role: data.role,
          description: data.description,
          id: data.id
        }
    
        console.log(formattedData)
    
    //     try {
    //       if (rowData) {
    //           const response = await UpdatePharmacy(formattedData);
    //           if (response.status === true) {
    //               toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
    //           }
    //           navigate(`${process.env.PUBLIC_URL}/pharmacy/:layout>}`)
    //       } else {
    //           const response = await CreatePharmacy(formattedData);
    //           if (response.status === true) {
    //               toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
                  
    //           }
    //           navigate(`${process.env.PUBLIC_URL}/pharmacy/:layout>}`)
    //       }
    //   } catch (error) {
    //       toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
    //   }
        reset()
        
      };

      const handleDelete = async () => {
        const result = await SweetAlert.fire({
          title: 'Are you sure you want to delete?',
          cancelButtonText: 'No!',
          confirmButtonText: 'Yes!',
          reverseButtons: true,
          showCancelButton: true,
        });
      
        // if (result.isConfirmed) {
        //   try {
        //     const selectedIds = selectedRows.map(row => row.id); 
        //     await Promise.all(selectedIds.map(id => DeletePharmacy(id)));
        //     setSelectedRows([]);
        //     toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
        //     fetchPharmacy()
        //   } catch (error) {
        //     toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        //   }
        // }
      };
    return(
        <>  
        <Breadcrumbs mainTitle='Roles' parent='Dashboard' title='roles' />
        <div className="d-flex justify-content-between p-3">
            <H3>Role and Description</H3>
        <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: LargeModaltoggle }}>+ Add Treatment Plan</Btn>
        <Modal isOpen={large}  size="lg"centered >
            
            <div className="d-flex justify-content-between">
              <ModalHeader>Role and Description</ModalHeader>
              <div className='p-3' style={{cursor: "pointer"}} onClick={LargeModaltoggle}> <CloseModal/> </div>
            </div>
            <ModalBody>
            <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
                <FormGroup>
                    <Label>Role Type</Label>
                    <input className={`form-control ${errors.role && "is-invalid"}`} id="role" type="text" name="role" defaultValue={formdata.role } {...register("role", { required: true })} />
                    <span className="text-danger">{errors.role && "Role Type is required"}</span>
                </FormGroup>
                <FormGroup>
                    <Label>Role Type</Label>
                    <input className={`form-control ${errors.description && "is-invalid"}`} id="description" type="text" name="description" defaultValue={formdata.description } {...register("description", { required: true })} />
                    <span className="text-danger">{errors.description && "Description is required"}</span>
                </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
              <Btn attrBtn={{ color: 'secondary', onClick: LargeModaltoggle }}>{"Close"}</Btn>
              <Btn attrBtn={{ color: 'primary', type: 'submit' }}>{"SaveChanges"}</Btn>
          </ModalFooter>
        </Modal>
        </div>
         <DataTable
                data={roleList}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
        </>
    )
}

export default Role